import { Injectable, OnDestroy } from '@angular/core'
import { MatDialog } from '@angular/material/dialog'
import {
  OfflineService,
  PERMISSIONS,
  SESSION_STORAGE,
  StorageService,
  User,
  Util,
} from '@phdsoft/common'
import { ElementTypeModel } from 'projects/phdsoft/common/src/lib/models/element-type.model'
import { ElementInsertionSelectionComponent } from '../digital-twin/element-insertion-selection/element-insertion-selection.component'
import { Graphics } from '../digital-twin/graphics/graphics'
import { GraphicsMaterials } from '../digital-twin/graphics/graphics-materials'
import { GraphicsRenderRepair } from '../digital-twin/graphics/graphics-render-repair'
import { BufferGeometry } from '@phdsoft/three'
import * as THREE from '@phdsoft/three'
import { mergeVertices } from 'three/examples/jsm/utils/BufferGeometryUtils.js';
import { ProtectionElementsCampaign } from "../platform/busines-data/Campaigns/ProtectionElementsCampaign";
import { TemplateService } from "../template/template.service";
import { AssetManager } from "./asset-manager";
import { v4 as uuid } from 'uuid';
import { LinearElement } from "../platform/busines-data/SectionElements/StructureElements/LinearElement";
import { BasicElement } from "../platform/busines-data/SectionElements/BasicElement/BasicElement";
import { WorkableElement } from "../platform/busines-data/SectionElements/WorkableElement";
import { ElementInsertionService } from "../admin/services/element-insertion.service";
import { BasicElementModel } from "projects/phdsoft/common/src/lib/models/basic-element.model";
import { ElementGeometryModel } from "projects/phdsoft/common/src/lib/models/element-type.model copy";
import { NotificationService } from "../signalr/notification.service";
import { GraphicsRenderDecal } from "../digital-twin/graphics/graphics-render-decal";
import { DTSelectionService } from "../digital-twin/selection/selection.service";
import { ELEMENTSTYPESIDS } from "projects/phdsoft/common/src/lib/shared/constants/elementsTypesIds";
import { ElementResultInfo } from 'projects/phdsoft/common/src/lib/models/element-result-info.model';
import { InspectionPlanService } from "../inspection-plan/inspection-plan.service";
import { MatSnackBar } from '@angular/material/snack-bar';
import { ClusterElementViewModel } from "projects/phdsoft/common/src/lib/models/cluster-element.model";
import { ClusterService } from "../cluster/cluster.service";
import { IProtectionElementData } from "projects/phdsoft/common/src/lib/models/protection-element-data.model";
import { GenerateLabel } from "projects/phdsoft/common/src/lib/models/generate-label";


@Injectable({ providedIn: 'root' })
export class AssetManagerElementInsertion implements OnDestroy {
  public element: ElementTypeModel
  public elementType: string
  public insertionMethod: string
  public Label: string
  public ActionId: string
  isSavingProtectionElement: boolean = false

  public get currentProtectionElementsCampaign(): ProtectionElementsCampaign {
    return this.assetManager.currentProtectionElementsCampaign
  }
  public set currentProtectionElementsCampaign(value: ProtectionElementsCampaign) {
    this.assetManager.currentProtectionElementsCampaign = value
  }

  constructor(
    private graphics: Graphics,
    private assetManager: AssetManager,
    private graphicsRenderRepair: GraphicsRenderRepair,
    private dialog: MatDialog,
    private templateService: TemplateService,
    private elementService: ElementInsertionService,
    private notificationService: NotificationService,
    private graphicsRenderDecal: GraphicsRenderDecal,
    private storageService: StorageService,
    private clusterService: ClusterService,
    private inspectionPlanService: InspectionPlanService,
    private snackBar: MatSnackBar,
    private offlineService: OfflineService,
  ) { }

  startElementInsertionSelection(elementType: string) {
    this.assetManager.functionalityMode = 'ELEMENTINSERTION'
    this.graphicsRenderRepair.forceRectangleShape();
    this.graphics.Controls.enableRotate = false

    this.templateService.toggleElementInsertionSelection(true, elementType)
  }

  async startElementInsertion(
    ev,
    sectionId: string,
    regionIds: Array<string>,
    selectionService: DTSelectionService,
  ) {
    if (
      this.assetManager.functionalityMode !== 'ELEMENTINSERTION' ||
      sectionId == null ||
      regionIds == null
    ) {
      return
    }

    switch (this.element?.Category) {
      case 'Protection':
        switch (this.insertionMethod) {
          case 'Icon':
            const box = this.assetManager.asset
              .GetStructureVisibleRegions()[0]
              .sections.find((x) => x.Guid === sectionId).box3
            let _inspectionPointsGeneral = this.graphicsRenderDecal.insertIconElement(
              ev,
              box,
              this.assetManager.asset,
              sectionId,
            )
            if (_inspectionPointsGeneral != null) {
              for (const _inspectionPoint of _inspectionPointsGeneral) {
                let _target: WorkableElement = null
                for (const structureCollection of this.assetManager.asset.StructureCampaigns) {
                  if (sectionId) {
                    for (const regionId of regionIds) {
                      _target = structureCollection.getElementById(
                        regionId,
                        sectionId,
                        _inspectionPoint.target.name,
                      )
                      if (_target) break
                    }
                    if (_target) break
                  } else {
                    for (const regionId of regionIds) {
                      _target = structureCollection.getElementByIdOnly(
                        regionId,
                        _inspectionPoint.target.name,
                      )
                      if (_target) break
                    }
                    if (_target) break
                  }
                }

                let protectionElement = new BasicElement(
                  uuid() as string,
                  _inspectionPoint.point,
                  GraphicsMaterials.anodeMaterial,
                  this.assetManager.currentRegion.Guid,
                  this.assetManager.currentSection.Guid,
                  this.element.Id,
                  this.element.Category,
                  this.insertionMethod,
                  this.Label,
                  this.ActionId,
                )

                let getLabel = {
                  assetId: this.assetManager.asset.assetInfo.AssetId,
                  regionId: this.assetManager.currentRegion.Guid,
                  elementId: this.element.Id,
                  elementCategory: this.element.Category,
                  labelPrefix: this.element.Name,
                }

                protectionElement.TypeId = this.getTypeId(this.element.Name)
                //protectionElement.ActionId = this.getActionId(this.element.Name)
                protectionElement.createdAt = this.assetManager.referenceDate
                protectionElement.regionIds = _target?.regionIds
                protectionElement.targetElements ??= []
                protectionElement.targetElements.push(_target.Guid)
                protectionElement.Label = await this.getElementLabel(getLabel)

                this.addElementProperties(protectionElement, this.element.Name)

                if (_target instanceof LinearElement) {
                  this.currentProtectionElementsCampaign.addLinearElement(
                    protectionElement,
                    _target,
                  )
                } else {
                  this.currentProtectionElementsCampaign.addSurfaceElement(protectionElement)
                }

                const elementModel = this.createElementModel(protectionElement)
                this.elementService.createElement(elementModel).subscribe((element) => {
                  let localElement =
                    this.assetManager.currentProtectionElementsCampaign.getElementByIdOnly(
                      elementModel.RegionId,
                      elementModel.id,
                    ) as BasicElement
                  localElement.createdAt = element.CreatedAt
                  this.notificationService.addSuccessNotification('Element Added')
                })

                // Convert BasicElement to ElementResultInfo

                const protectionElementModel = this.createProtectionElementModel(
                  protectionElement,
                  _target,
                )

                this.upsertProtectionElement(protectionElementModel)

                selectionService.clearElementSelected('', this.assetManager.asset)
                selectionService.markElementSelected(
                  protectionElement.Guid,
                  this.assetManager.asset,
                )
              }
            }
        }
    }
  }

  // BEGIN CREATING ELEMENTMODEL

  createProtectionElementModel(element: BasicElement, target: any): ElementResultInfo {
    const vertices = []
    const faces = []
    const geometry = element.SurfaceDesign.geometry as BufferGeometry
    if (element.insertionMethod === 'Icon') {
      vertices.push(
        ...[
          element.SurfaceDesign.position.x,
          element.SurfaceDesign.position.y,
          element.SurfaceDesign.position.z,
        ],
      )
    } else {
      vertices.push(...Array.from(geometry.attributes.position.array))
    }
    faces.push(...Array.from(geometry.index.array))

    let elementGeometry: ElementGeometryModel = {
      Vertices: vertices,
      Faces: faces,
    }

    if (!element.createdAt) {
      element.createdAt = this.assetManager.referenceDate
    }

    return {
      id: element.Guid,
      Label: element.Label,
      AssetId: this.assetManager.asset.assetInfo.AssetId,
      RegionIds: element.regionIds,
      SectionId: element.SectionId,
      CheckList: [
        {
          CreatedAt: element.createdAt,
          Date: element.createdAt,
          Value: '',
        },
      ],
      IsPlanned: true,
      InsertedRegionId: element.regionId,
      Element: element,
      InspectionMethodId: element.insertionMethod,
      InspectionTypeId: element.properties.TypeId,
      TargetGeometryId: this.assetManager.currentSection.Guid,
      TargetGeometryTypeId: element.properties.TypeId,
      Scope: 'NONE',
    }
  }

  private getTypeNameById(item): any {
    let TypeId
    if (item.properties.TypeName) {
      TypeId = item.properties.TypeName
    } else if (this.assetManager.currentSelectedElement) {
      TypeId = this.assetManager.currentSelectedElement
    }
    switch (TypeId) {
      case ELEMENTSTYPESIDS.ANODE:
        return 'Anode'
      case ELEMENTSTYPESIDS.PROTECTION:
        return 'Protection'
      case ELEMENTSTYPESIDS.PAINTING:
        return 'Painting'
      default:
        return ''
    }
  }

  private MapActionTypeByElementId(item): any {
    let TypeId
    if (item.properties.TypeName) {
      TypeId = item.properties.TypeName
    } else if (this.assetManager.currentSelectedElement) {
      TypeId = this.assetManager.currentSelectedElement
    }
    return this.getTypeId(TypeId)
  }

  formatDateToISOString(date: Date): string {
    const z = (n: number) => (n < 10 ? '0' : '') + n

    return `${date.getUTCFullYear()}-${z(date.getUTCMonth() + 1)}-${z(date.getUTCDate())}T${z(
      date.getUTCHours(),
    )}:${z(date.getUTCMinutes())}:${z(date.getUTCSeconds())}.000Z`
  }

  ////////////////////////////////////////////////////////////////

  public async upsertProtectionElement(protectionElement: any) {
    const uniqueDatesFromChecklist: Date[] = [
      ...new Set(protectionElement.CheckList.map((x) => x.Date)),
    ] as Date[]

    if (!this.isSavingProtectionElement) {
      let targets = []

      let isExecutedValue = protectionElement.Element?.elementProperties?.find(
        (p) => p.Name === 'Executed',
      )?.Value

      if (isExecutedValue) {
        await this.assetManager.estimateDegradationByCurveParameters()
      }

      if (!this.assetManager.asset.repairsList || this.assetManager.asset.repairsList.length == 0) {
        await this.assetManager.loadRepairsToTimeline()
      }

      // var elementInsertRenew = this.assetManager.asset.repairsList.find(
      //   (x) => x.name === 'Insert Anode',
      // )

      var elementInsertRenew = this.findRepairByName(this.assetManager.asset.mitigationsList);

      if (elementInsertRenew && !isExecutedValue) {
        var date = new Date(this.assetManager.referenceDate)

        const protectionElementData: IProtectionElementData = {
          id: protectionElement.Element.Guid,
          actionId: elementInsertRenew.id,
          followUpDate: new Date(date.setMonth(date.getMonth())),
          assetId: this.assetManager.asset.assetInfo.AssetId,
          regionId: protectionElement.InsertedRegionId,
          elementTypeId: protectionElement.Element.TypeId,
          anomalyActionId: elementInsertRenew.id,
        }

        await this.inspectionPlanService.createActionPlanForProtection(protectionElementData)
      } else {
        const data: Array<ClusterElementViewModel> = new Array<ClusterElementViewModel>()
        data.push({
          ClusterType: 'Protection',
          AssetId: this.assetManager.asset.assetInfo.AssetId,
          RegionIds: protectionElement.regionIds,
          Dates: [protectionElement.date],
          InspectionTypeId: ELEMENTSTYPESIDS.PROTECTION,
        })
        await this.clusterService.RegenerateClustersIfNeeded(data).toPromise()
      }
    } else {
      this.snackBar.open('Please Wait while we finish saving the element', '', {
        horizontalPosition: 'right',
        verticalPosition: 'bottom',
        duration: 3000,
      })
    }
  }

  public async upsertProtectionElementLite(protectionElement: any) {
    const uniqueDatesFromChecklist: Date[] = [...new Set(protectionElement.CreatedAt)] as Date[]

    if (!this.isSavingProtectionElement) {
      let targets = []

      let isExecutedValue = protectionElement.elementProperties?.find(
        (p) => p.Name === 'Executed',
      )?.Value

      if (isExecutedValue) {
        await this.assetManager.estimateDegradationByCurveParameters()
      }

      if (!this.assetManager.asset.repairsList || this.assetManager.asset.repairsList.length == 0) {
        await this.assetManager.loadRepairsToTimeline()
      }

      var elementInsertRenew = this.assetManager.asset.repairsList.find(
        (x) => x.name === 'Insert Anode',
      )

      if (elementInsertRenew && !isExecutedValue) {
        var date = new Date(this.assetManager.referenceDate)

        const protectionElementData: IProtectionElementData = {
          id: protectionElement.id,
          actionId: elementInsertRenew.id,
          followUpDate: new Date(date.setMonth(date.getMonth())),
          assetId: this.assetManager.asset.assetInfo.AssetId,
          regionId: protectionElement.RegionId,
          elementTypeId: this.getTypeId(this.element.Name),
          anomalyActionId: elementInsertRenew.id,
        }

        await this.inspectionPlanService.createActionPlanForProtection(protectionElementData)
      } else {
        const data: Array<ClusterElementViewModel> = new Array<ClusterElementViewModel>()
        data.push({
          ClusterType: 'Protection',
          AssetId: this.assetManager.asset.assetInfo.AssetId,
          RegionIds: protectionElement.regionIds,
          Dates: [protectionElement.CreatedAt],
          InspectionTypeId: ELEMENTSTYPESIDS.PROTECTION,
        })
        await this.clusterService.RegenerateClustersIfNeeded(data).toPromise()
      }
    } else {
      this.snackBar.open('Please Wait while we finish saving the element', '', {
        horizontalPosition: 'right',
        verticalPosition: 'bottom',
        duration: 3000,
      })
    }
  }

  public async deleteProtectionElement(protectionElement: any) {
    const data: ClusterElementViewModel = {
      ClusterType: "Protection",
      AssetId: this.assetManager.asset.assetInfo.AssetId,
      RegionIds: protectionElement.regionIds,
      Dates: [protectionElement.date],
      //InspectionTypeId: protectionElement.inspectionTypeId
    };
    //await this.clusterService.RegenerateClustersIfNeeded(data).toPromise();
    await this.clusterService.RegenerateClustersIfNeededWhenDeleted(data).toPromise();
  }

  // private getDatesNotClusterized(dates: Date[], typeId: string): Date[] {
  //   if (this.clusterState.ClusterState.items.length === 0) {
  //     return dates
  //   }

  //   return dates.filter((date) => {
  //     return !this.clusterState.ClusterState.items.some(
  //       (item) => item.date.toString() === date.toString() && item.typeId === typeId,
  //     )
  //   })
  // }

  // private getDataToSave(
  //   pCollection: ElementResultInfo,
  //   datesFromChecklistNotClusterized: Date[],
  // ): ClusterElementViewModel[] {
  //   if (datesFromChecklistNotClusterized.length === 0) return []
  //   return [
  //     {
  //       ClusterType: 'Protection',
  //       AssetId: pCollection.AssetId,
  //       RegionIds: pCollection.RegionIds,
  //       Dates: datesFromChecklistNotClusterized,
  //       InspectionTypeId: pCollection.InspectionTypeId,
  //     },
  //   ]
  // }

  ////////////////////////////////////////////////////////////////
  // END CREATING ELEMENTMODEL

  initializeElementInsertion() {
    this.graphicsRenderRepair.threeStartGeometryCloning()
    this.graphics.rectd.startRectangleSelection = true
  }

  FinishInsertElement(selectionService: DTSelectionService) {
    switch (this.element.Category) {
      case 'Protection':
        switch (this.insertionMethod) {
          case 'Area':
            if (Util.isNullOrUndefined(this.currentProtectionElementsCampaign)) {
              this.addNewProtectionElementCollection(new Date(this.assetManager.referenceDate), null, null)
            }
            if (!Util.isNullOrUndefined(this.graphicsRenderRepair.rectd.meshs)) {
              for (let i = 0; i < this.graphicsRenderRepair.rectd.meshs.length; i++) {
                const _mesh = this.graphicsRenderRepair.rectd.meshs[i]
                if (_mesh?.geometry instanceof BufferGeometry)
                  _mesh.geometry = mergeVertices(
                    _mesh?.geometry as BufferGeometry,
                  )
                // const target = this.graphicsRenderRepair.rectd.targets[0];
                // let _repair: Repair
                // const _target = this.assetManager.asset.getStructureElements(false).find(x => x.Guid === target.name);
                if (this.graphicsRenderRepair.rectd.targets) {
                  let targets = []
                  this.graphicsRenderRepair.rectd.targets.forEach((target) => {
                    for (const structureCollection of this.assetManager.asset.StructureCampaigns) {
                      let _target = structureCollection.getElementByIdOnly(
                        this.assetManager.currentRegion.Guid,
                        target.name,
                      )
                      if (_target) {
                        targets.push(_target)
                        break
                      }
                    }
                  })

                  let protectionElement = new BasicElement(
                    uuid() as string,
                    _mesh,
                    GraphicsMaterials.paintMaterial,
                    this.assetManager.currentRegion.Guid,
                    this.assetManager.currentSection.Guid,
                    this.element.Id,
                    this.element.Category,
                    this.insertionMethod,
                    this.Label,
                    this.ActionId,
                  )
                  protectionElement.regionIds = targets[0]?.regionIds
                  protectionElement.targetElements ??= []
                  protectionElement.targetElements = targets.map((target) => target.Guid)
                  this.addElementProperties(protectionElement, this.element.Name)
                  if (targets[0] instanceof LinearElement) {
                    this.currentProtectionElementsCampaign.addLinearElement(
                      protectionElement,
                      targets[0],
                    )
                  } else {
                    this.currentProtectionElementsCampaign.addSurfaceElement(protectionElement)
                  }

                  const elementModel = this.createElementModel(protectionElement)

                  this.elementService.createElement(elementModel).subscribe((element) => {
                    let localElement =
                      this.assetManager.currentProtectionElementsCampaign.getElementByIdOnly(
                        elementModel.RegionId,
                        elementModel.id,
                      ) as BasicElement
                    localElement.createdAt = element.CreatedAt
                    this.notificationService.addSuccessNotification('Element Added')
                  })
                  selectionService.clearElementSelected('', this.assetManager.asset)
                  selectionService.markElementSelected(
                    protectionElement.Guid,
                    this.assetManager.asset,
                  )
                }
              }
            }
            break

          case 'Icon':
            break

          default:
            break
        }
        break

      case 'Structure':
        break

      default:
        break
    }

    this.graphicsRenderRepair.rectd.meshs = []
    this.graphicsRenderRepair.rectd.targets = []
  }

  addElementProperties(element: BasicElement, typeName: string) {
    let elementType = this.assetManager.assetElementTypes.find(
      (e) => e.Id === element.elementNameId,
    )
    if (!elementType) {
      // error message
    }
    if (elementType) {
      element.elementProperties = []
      for (let i = 0; i < elementType.Properties.length; i++) {
        element.elementProperties.push({
          PropertyId: elementType.Properties[i],
          Value: null,
        })
      }
      element.properties = {
        TypeName: typeName,
        TypeId: this.getTypeId(typeName),
      }
    }
  }

  getTypeId(item) {
    //let typeName = item.toLowerCase()
    let typeName = this.getTypeName(item.toLowerCase())
    switch (typeName) {
      case 'anode':
        return ELEMENTSTYPESIDS.ANODE
      case 'protection':
        return ELEMENTSTYPESIDS.PROTECTION
      case 'painting':
        return ELEMENTSTYPESIDS.PAINTING
      default:
        return '-'
    }
  }

  getTypeName(typeName) {
    // Convert typeName to lowercase
    typeName = typeName.toLowerCase();

    // Check if typeName contains 'anode', 'protection', or 'painting'
    if (typeName.includes('anode')) {
      typeName = 'anode';
    } else if (typeName.includes('protection')) {
      typeName = 'protection';
    } else if (typeName.includes('painting')) {
      typeName = 'painting';
    }

    return typeName;
  }

  addNewProtectionElementCollection(date: Date, elementName: string, insertionMethod: string) {
    let _newCollection = new ProtectionElementsCampaign(date, null, elementName, insertionMethod)
    this.assetManager.asset.addProtectionElementsCollection(_newCollection)
    this.currentProtectionElementsCampaign = _newCollection
    return _newCollection
  }

  createElementModel(element: BasicElement): BasicElementModel {
    const vertices = []
    const faces = []
    const geometry = element.SurfaceDesign.geometry as BufferGeometry
    if (element.insertionMethod === 'Icon') {
      vertices.push(
        ...[
          element.SurfaceDesign.position.x,
          element.SurfaceDesign.position.y,
          element.SurfaceDesign.position.z,
        ],
      )
    } else {
      vertices.push(...Array.from(geometry.attributes.position.array))
    }
    faces.push(...Array.from(geometry.index.array))

    let elementGeometry: ElementGeometryModel = {
      Vertices: vertices,
      Faces: faces,
    }

    if (!element.createdAt) {
      element.createdAt = this.assetManager.referenceDate
    }

    return {
      id: element.Guid,
      Label: element.Label,
      AssetId: this.assetManager.asset.assetInfo.AssetId,
      RegionId: element.regionId,
      RegionIds: element.regionIds,
      SectionId: element.SectionId,
      InsertionMethod: element.insertionMethod,
      ElementCategory: element.elementCategory,
      ElementNameId: element.elementNameId,
      ElementProperties: element.elementProperties,
      Geometry: elementGeometry,
      TargetElements: element.targetElements,
      CreatedAt: element.createdAt,
    }
  }

  async loadRegionElements(regionId: string) {
    // workaround to not load elements for all users while clusterization is not implemented
    const user: User = await this.storageService.getItem(SESSION_STORAGE.USER, true)
    const assetPermission = user.AssetPermissions.find(
      (item) => item.AssetId == this.assetManager.asset.assetInfo.AssetId,
    )
    if (!assetPermission.PermissionIds?.includes(PERMISSIONS.INSERT_PROTECTION_ELEMENTS)) {
      return
    }

    if (Util.isNullOrUndefined(this.currentProtectionElementsCampaign)) {
      this.addNewProtectionElementCollection(new Date(this.assetManager.referenceDate), null, null)
    }


    let elements: BasicElementModel[] = []
    if (window.navigator.onLine) {
      elements = await this.elementService
        .getAssetElements(this.assetManager.asset.assetInfo.AssetId, regionId)
        .toPromise()
    } else {
      const dbStoreData = await this.offlineService.getItem(`elements_region_${this.assetManager.asset.assetInfo.AssetId}_${regionId}`)
      elements = dbStoreData?.json
    }

    for (let i = 0; i < elements.length; i++) {
      const geometry = new THREE.BufferGeometry()
      geometry.setAttribute(
        'position',
        new THREE.BufferAttribute(new Float32Array(elements[i].Geometry.Vertices), 3),
      )
      if (elements[i].Geometry.Faces && elements[i].Geometry.Faces.length > 0)
        geometry.setIndex(elements[i].Geometry.Faces)
      geometry.computeVertexNormals()

      let material: THREE.Material = null
      if (elements[i].InsertionMethod === 'Area') {
        material = GraphicsMaterials.paintMaterial
      } else {
        material = GraphicsMaterials.anodeMaterial
      }

      let _mesh = new THREE.Mesh(geometry, material)
      // need calibration if point shape
      let _target = null
      if (elements[i].InsertionMethod === 'Icon') {
        for (const structureCollection of this.assetManager.asset.StructureCampaigns) {
          _target = structureCollection.getElementByIdOnly(
            this.assetManager.currentRegion.Guid,
            elements[i].TargetElements[0],
          )
          if (_target) {
            break
          }
        }
        if (_target) {
          _mesh = this.graphicsRenderDecal.createIconFromPosition(
            elements[i].Geometry.Vertices,
            _target,
            _target.section.sectionNormal.normalize(),
            _target.section.box3,
          )
        }
      }

      let element = new BasicElement(
        elements[i].id,
        _mesh,
        material,
        elements[i].RegionId,
        elements[i].SectionId,
        elements[i].ElementNameId,
        elements[i].ElementCategory,
        elements[i].InsertionMethod,
        elements[i].Label,
        this.ActionId,
      )
      element.elementProperties = elements[i].ElementProperties
      element.targetElements = elements[i].TargetElements
      element.regionIds = elements[i].RegionIds
      element.createdAt = elements[i].CreatedAt
      element.properties = { TypeName: 'Anode' } || { TypeName: 'Protection' }
      element.TypeId = ELEMENTSTYPESIDS.ANODE || ELEMENTSTYPESIDS.PROTECTION
      element.target = _target
      if (_target instanceof LinearElement) {
        this.currentProtectionElementsCampaign.addLinearElement(element, _target)
      } else {
        this.currentProtectionElementsCampaign.addSurfaceElement(element)
      }
    }
  }

  async getElementLabel(newLabel: GenerateLabel): Promise<string> {
    let label = await this.elementService.getNextGeneratedElementLabel(newLabel)
    return label
  }

  findRepairByName(list) {
    const keywords = ['insert', 'renew'];
    return list.find((x) => {
      const normalizedItemName = x.name.toLowerCase().replace(/\s/g, '');
      return keywords.some(keyword => normalizedItemName.includes(keyword));
    });
  }

  ngOnDestroy(): void {
    throw new Error('Method not implemented.')
  }
}
